import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Button } from './ui/Button';
export function StickyNav() {
  const [isVisible, setIsVisible] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      // Show nav after scrolling past hero (approx 600px)
      if (window.scrollY > 600) {
        setIsVisible(true);
      } else {
        setIsVisible(false);
      }
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  return <AnimatePresence data-id="element-333">
      {isVisible && <motion.nav initial={{
      y: -100,
      opacity: 0
    }} animate={{
      y: 0,
      opacity: 1
    }} exit={{
      y: -100,
      opacity: 0
    }} transition={{
      duration: 0.3
    }} className="fixed top-0 left-0 right-0 z-50 bg-white/90 backdrop-blur-md border-b border-gray-100 shadow-sm py-3" data-id="element-334">
          <div className="container mx-auto px-4 max-w-5xl flex items-center justify-between" data-id="element-335">
            <span className="font-serif font-bold text-xl text-[#1B4332]" data-id="element-336">
              Rodilla Sin Miedo
            </span>
            <Button size="default" data-id="element-337">Empezar hoy</Button>
          </div>
        </motion.nav>}
    </AnimatePresence>;
}